import React, { useEffect, useState } from "react";
import Banner from "../../../views/components/sections/Banner";
import { Form } from "antd";
import { useMessageApi } from "../../../provider/AntdNotification";
import { usePageDetail, usePageSave } from "../../../hooks/api/pages/hooks";
import { useQueryState } from "nuqs";
import TabsContain from "../../../views/components/reuseComp/TabsContain";
import { getSingleImageUrl } from "../../../lib/utils";
import ImageSection from "./ImageSection";
import { IGalleryPagePayload, IPagePayload } from "@src/types/api/pages";

const GalleryTabs: React.FC<{
  setBreadcrumb: (breadcrumb: string) => void;
}> = ({ setBreadcrumb }) => {
  const message = useMessageApi();
  const [tab, setTab] = useQueryState("tab");
  const { data } = usePageDetail("GALLERY");
  const [pageData, setPageData] = useState<any>(null);
  const activeTab = tab || "Banner";

  const [isEditing, setIsEditing] = useState(false);
  const { mutate: updateService, isPending } = usePageSave({});

  useEffect(() => {
    if (data?.data) setPageData(data.data);
  }, [data]);

  const sections = ["Banner", "Images"];
  const [form] = Form.useForm();

  const handleCancel = () => {
    setIsEditing(false);
    form.resetFields();
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();

      const payload: IGalleryPagePayload = {
        _id: pageData?._id,
        pageType: "GALLERY",

        banner:
          activeTab === "Banner"
            ? {
                heading: values?.banner?.heading || "",
                image: getSingleImageUrl(values?.banner?.image),
              }
            : pageData?.banner, // preserve old banner

        galleryImages:
          activeTab === "Images"
            ? values?.galleryImages || []
            : pageData?.galleryImages, // preserve old images
      };

      updateService(payload, {
        onSuccess: (res) => {
          message.success("Page updated successfully");
          setPageData(res.data);
          setIsEditing(false);
        },
        onError: () => {
          message.error("Failed to update page");
        },
      });
    } catch (error) {
      console.log("❌ Validation failed:", error);
    }
  };
  const handleChangeTab = (section: string) => {
    setTab(section);
    setIsEditing(false);
    setBreadcrumb(section);
  };

  return (
    <div>
      <TabsContain
        handleChangeTab={handleChangeTab}
        activeTab={activeTab}
        sections={sections}
      />

      {activeTab === "Banner" && (
        <Banner
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
          bannerData={pageData?.banner}
          loading={isPending}
          form={form}
        />
      )}
      {activeTab === "Images" && (
        <ImageSection
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
          form={form}
          imageData={pageData?.galleryImages}
          loading={isPending}
        />
      )}
    </div>
  );
};

export default GalleryTabs;
